export enum eVendorTitleSearchType {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  UPLOADABLE = 'uploadable',
}
